import { useEffect, useCallback, useState } from 'react';

/**
 * @param props {Object}
 * @param props.callback {Function}
 * @param [props.observeOptions] {Object}
 */
export const useResizeObserver = ({ callback, observeOptions }) => {
    const [observer, setObserver] = useState(null);

    useEffect(() => {
        const resizeObserver = new ResizeObserver(callback);

        setObserver(resizeObserver);

        return () => {
            resizeObserver.disconnect();
        };
    }, [callback]);

    return useCallback((node) => {
        if (node && observer) {
            observer.observe(node, observeOptions);
        }
    }, [observer, observeOptions]);
};
